<template>
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate>
        <div class="text-right ml-1">
            <b-button variant="link" @click="redirectToList">
                {{ $t('vueFormWizard.backButtonText') }}
            </b-button>
        </div>

        <div v-for="(committee, index) in $v.form.committees.$each.$iter" :key="committee.id.$model">
            <b-card>
                <div class="mb-3 text-right">
                    <b-button
                        variant="danger"
                        class="float-right ml-1"
                        size="sm"
                        :title="$t('committees.clickToDelete')"
                        @click="form.committees = removeCommittee(committee.id.$model, form.committees)"
                        :disabled="!committee.id.$model"
                        v-if="!committees"
                    >
                        <i class="fas fa-trash fa-lg" />
                    </b-button>

                    <b-button
                        variant="success"
                        class="float-right ml-1"
                        size="sm"
                        :title="$t('form.button.enterACommittee')"
                        @click="form.committees = addNewCommittee(form.committees)"
                        v-if="!committees"
                    >
                        <i class="fas fa-plus fa-lg" />
                    </b-button>
                </div>
                <b-form-group :label="`${$t('form.label.title')}*`" label-for="title">
                    <b-row>
                        <b-col md="12" xl="12">
                            <b-form-input
                                class="mb-2"
                                :id="`input-value-id-${committee.id.$model}-feedback`"
                                ref="title"
                                type="text"
                                :placeholder="$t('form.placeholder.title')"
                                :state="checkArrayState(committee, 'title')"
                                v-model="committee.title.$model"
                                :aria-describedby="`input-value-id-${committee.id.$model}-feedback`"
                                autocomplete="committee"
                                autofocus
                            />
                            <b-form-invalid-feedback :id="'id' + committee.id.$model">
                                <span v-if="!$v.form.committees.$each[index].title.required">
                                    {{ $t('form.validations.required') }}
                                </span>
                                <span v-if="!$v.form.committees.$each[index].title.maxLength">
                                    {{
                                        $t('form.validations.maxLength', {
                                            value: '255',
                                        })
                                    }}
                                </span>
                            </b-form-invalid-feedback>
                        </b-col>

                        <b-col md="12" xl="12">
                            <c-users
                                :value.sync="committee.users.$model"
                                :state="checkArrayState(committee, 'users')"
                                :multiple="true"
                                :aria-describedby="`input-value-id-${committee.id.$model}-feedback`"
                                :allowEmpty="true"
                                :id="`input-value-id-${committee.id.$model}`"
                                label="Usuários*"
                                @already-selected-user="saveAlreadySelectedUsersInForm($event)"
                            />
                        </b-col>
                    </b-row>
                </b-form-group>
            </b-card>
        </div>
        <div v-if="form.committees.length">
            <ButtonLoader class="float-right ml-1" type="submit" variant="primary" :loader="loader">
                {{ $t('form.button.save') }}
            </ButtonLoader>

            <b-button class="float-right" variant="secondary" :disabled="loader" @click="redirectToList">
                {{ $t('form.button.cancel') }}
            </b-button>
        </div>
    </b-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, decimal } from 'vuelidate/lib/validators'
import ButtonLoader from '@/views/components/button-loader'
import { Users as CUsers } from '@/views/components/fields'
import { cloneDeep } from 'lodash'

const initialState = {
    committees: [
        {
            id: null,
            title: null,
            users: [],
        },
    ],
}

export default {
    name: 'Form',
    components: {
        ButtonLoader,
        CUsers,
    },
    mixins: [validationMixin],
    data() {
        return {
            form: cloneDeep(initialState),
            loader: false,
        }
    },
    props: ['committees'],
    validations: {
        form: {
            committees: {
                $each: {
                    id: {},
                    title: {
                        required,
                        maxLength: maxLength(255),
                    },
                    users: {
                        required,
                        $each: {
                            value: {
                                required,
                                decimal,
                            },
                        },
                    },
                },
            },
        },
    },
    computed: {
        isValid() {
            return !this.$v.form.$anyError
        },
        isDirty() {
            return this.$v.form.$anyDirty
        },
    },
    methods: {
        saveAlreadySelectedUsersInForm(users) {
            this.$v.form.committees.$each[0].users.$model = users
        },
        addNewCommittee(committees) {
            let newCommittee = {
                id: new Date().getTime(),
                title: '',
                users: [],
            }
            return [...cloneDeep(committees), newCommittee]
        },
        removeCommittee(id, committees) {
            return committees.filter((committee) => {
                return committee.id != id
            })
        },
        checkArrayState(current, key) {
            return current[key].$dirty ? !current[key].$invalid : null
        },
        onSubmit() {
            if (this.validate()) {
                this.$nextTick(() => {
                    this.$emit('onSubmit', this.form, this.onReset, this.isLoading)
                })
            }
        },
        isLoading(state) {
            this.loader = state
        },
        onReset() {
            this.form = cloneDeep(initialState)
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        validate() {
            this.$v.$touch()
            return this.isValid
        },
        redirectToList() {
            return this.$router.go(-1)
        },
    },
    watch: {
        committees(committees) {
            committees.map((resp) => {
                const objOfcommittees = {
                    committees: [
                        {
                            id: resp.id,
                            title: resp.title,
                            users: resp.users,
                        },
                    ],
                }
                this.form = cloneDeep(objOfcommittees)
            })
        },
    },
}
</script>

<style scoped>
.btn.disabled {
    cursor: auto;
}
</style>
